import { CaretRight, SealPercent } from "@phosphor-icons/react";
import { Icon } from "@shopflo/ui/icon";
import { useCheckoutContext } from "lib/contexts/CheckoutProvider";
import { useLocale } from "lib/hooks/useLocale";
import React from "react";
import { getCardBorderStyles } from "lib/utils/UIUtils";
import ViewOtherCouponsTile from "./ViewCouponsTile";
import { CouponStripProps } from "../couponProps";
import MultiGiftCard from "../cards/MultiGiftCard";
import GiftCard from "../cards/GiftCard";
import Gyftr from "../cards/Gyftr";
const CouponStrip: React.FC<CouponStripProps> = ({
  setCouponApplyError,
  availableCoupons,
  renderCouponSummaryStrip,
  showCoupons,
  customisations,
  onOpenPartnerOffers,
  onOpen,
  partnerOffersConfig,
}) => {
  const {
    actions: { setCheckoutModal },
  } = useCheckoutContext();
  const { t } = useLocale();

  const handleCouponListClick = () => {
    setCheckoutModal("DISCOUNT_LIST");
    setCouponApplyError({ status: false, message: "" });
  };

  return (
    <div
      className=" flex flex-col relative w-full cursor-pointer items-center justify-between rounded-xl border border-green-dark/20 bg-white overflow-hidden"
      id="flo_coupons_select"
      style={{
        borderRadius: customisations?.cardRadius,
        backgroundColor: customisations?.callout?.backgroundColor,
        ...getCardBorderStyles({
          borderSides: customisations?.cardBorderSides,
          borderWidth: customisations?.cardBorderWidth,
          borderColor: customisations?.callout?.borderColor,
        })
      }}
    >
      {showCoupons && (
        <div className="flex justify-between w-full px-3 py-3.5" onClick={handleCouponListClick}>
          <div className="flex w-3/5 items-center space-x-2 text-green-dark">
            <Icon IconComponent={SealPercent} size="sm" iconProps={{ weight: "fill", color: customisations?.callout?.primaryColor }}></Icon>
            <div className="flex flex-col"
            >
              {availableCoupons?.shopflo > 0 ? (
                <div className="ml-auto pr-1 text-text-sm-regular text-yay-dark"
                  style={{
                    color: customisations?.callout?.primaryColor,
                  }}
                >
                  {t("x_symbol_available", {
                    count: availableCoupons?.shopflo,
                    symbol: availableCoupons?.shopify > 0 ? "+" : "",
                  })}
                </div>
              ) : (
                <div className="text-text-sm-regular">{t("view_coupons")}</div>
              )}
            </div>
          </div>

          <Icon
            IconComponent={CaretRight}
            size="xxs"
            className="text-zinc-700/60"
            iconProps={{ weight: "bold", color: customisations?.callout?.infoColor }}
          />
        </div>
      )}
      <div className="w-full">{renderCouponSummaryStrip()}</div>
      <div className="flex flex-col justify-between border-t w-full"
        style={{ backgroundColor: customisations?.footer?.backgroundColor }}>
        <ViewOtherCouponsTile
          availableCoupons={availableCoupons}
          setCouponApplyError={setCouponApplyError}
          customisations={customisations}
          onOpenPartnerOffers={onOpenPartnerOffers}
          onOpen={onOpen}
          partnerOffersConfig={partnerOffersConfig}
        />
      </div>
      <div className="flex flex-col justify-between bg-green-dark/5 w-full text-green-dark">
      <GiftCard dividerColor="rgba(9, 9, 11, 0.06)" />
      <Gyftr dividerColor="rgba(9, 9, 11, 0.06)" />
        <MultiGiftCard dividerColor="rgba(9, 9, 11, 0.06)" />
      </div>
    </div>
  );
};

export default CouponStrip;
